module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/0-4c6f065d3d0072fb9e90ea09bd095e16.jpg";